import styled from 'styled-components';
import { DiscoverCardSkeleton } from '../discoverSkeleton/discoverSkeleton.styles';

export const DiscoverFeedCardSkeletonRoot = styled(DiscoverCardSkeleton)`
	scroll-snap-align: start;
	scroll-snap-stop: always;
`;
